export const round = (value, precision) => {
  const multiplier = Math.pow(10, precision || 0);
  return Math.round(value * multiplier) / multiplier;
};

export const getAvailable = (starting = 0, leave = 0, shrinkage = 0) => {
  return round(starting - round(leave, 1) - round(shrinkage, 1), 1);
};

export const getLeave = (planned = 0, unplanned = 0) => {
  return round(planned + unplanned, 1);
};
